import {
    Col,
    Row,
    Modal,
    Form,
    Input,
    Select,
    Popconfirm,
    TimePicker,
    Dropdown,
    Table,
    Spin,
    Collapse,
    Button,
    InputNumber,
} from "antd";
import { React, useEffect, useState } from "react";
import ButtonComp from "../../ButtonComp/ButtonComp";
import CustomTable from "../../Table/CustomTable";
import BasicFormItem from "../../BasicFormItem/BasicFormItem";
import Loader from "../../Helpers/Loader";
import "./PlannedDowntime.css";
import { CheckCircleFilled, edit, trash, CloseCircleFilled } from "../../../Utils/imports";
import { LineSettingsShiftForm } from "../../../Utils/constants";
import { PlannedDowntimeVar } from "../../../Utils/variables";
import { access_capabilities } from "../../../Utils/constants";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import SyncMachine from "../SyncMachine/SyncMachine";
import { CheckCircleOutlined } from "@ant-design/icons";
import { createAlert, deleteAlert, editAlert } from "../../../API-Interaction/apiServices/plantSettings.api";
import { antIcon, formatCapabilities, canPerformAction } from "../../../Helpers/helpers";
import { onDowntimeValuesSubmit,createPlannedDowntime } from "../../../API-Interaction/apiServices/productionLine.api";

import { v4 as uuidv4 } from 'uuid';
const { Panel } = Collapse;
const { TextArea } = Input;
const {
    heading1,
    heading2,
    add_downtime,
    add_stoppage,
    reason,
    stoppage_time,
    downtime,
} = PlannedDowntimeVar;

const PlannedDowntime = () => {
    const [form] = Form.useForm()
    const dispatch = useDispatch()
    const [selectedMachines, setState] = useState([]);
    const [currentRow, setCurrent] = useState({})
    let lineField = useSelector(state => state?.plant?.current?.plant?.productionLines);
    const { current = null} = useSelector(state => state.plant)
    let plannedDowntimes = current?.line?.plannedDowntimes || null
    let plannedDowntimesList = plannedDowntimes?.[current?.machine?.machineName] || plannedDowntimes?.['Default'] || null
    let downtimeSettings = plannedDowntimesList.
    filter(x => x.from).sort((a, b) =>  a.from.localeCompare(b.from))
    let stoppageSettings = plannedDowntimesList.filter(x => x.maxMinutes).sort((a,b) => a.maxMinutes - b.maxMinutes)
    //let stoppageSettings = //plannedDowntimes?.[current?.machine?.machineName] || plannedDowntimes?.['Default'] || null
    let {plant = null, machine = null} = current;
    const { pageLoaders, componentLoaders } = useSelector(state => state.utils.loaders)
    let lineOps = lineField.map((item) => (
        { value: item.id, label: item.lineName }
    ))
    const typeOps = [
        { value: "efficiency", label: "Efficiency" },
        { value: "lineSettingsUpdate", label: "Changes in Line Settings" },
        { value: "Speed_Set_Point", label: "Speed Set Point" },
        { value: "perform_yeild", label: "Perform Yeild" },
        { value: "Average_Brix", label: "Average Brix" },
        { value: "downtime", label: "Downtime" },
    ]

    const [stoppageModal, setStoppageModal] = useState(false);
    const [downtimeModal, setDowntimeModal] = useState(false);
    const [doWhat, setDoWhat] = useState('create');
    const [switches] = useState({ status: false, medium: false });
    let options = [];

    const handleChange = (...params) => {
        let [two] = params
        console.log(`${two}`);
    };
    const validateEmail = (email) => {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }
    const onEmailChange = (x) => {
        let newElem = x[x.length - 1]
        let toEmails = options
        if (toEmails.length > x.length || validateEmail(newElem))
            toEmails = x
        options = toEmails
    }
    const onFinish = async (values) => {
        let plannedDowntimes = []
        let updatedLog = null;
        let { plant = null, line = null, machine = null } = JSON.parse(localStorage.getItem('current'))
        plannedDowntimes = line.plannedDowntimes//[machine?.machineName||'Default'];
        if (doWhat === 'edit'){

            let index = plannedDowntimes[machine?.machineName||'Default'].findIndex(pd => pd.pdId == currentRow.pdId);
            //log.detailsBefore = currentRow
            //log.action = 'Planned Downtime Updated'
            if(!values.maxMinutes){
                plannedDowntimes[machine?.machineName||'Default'][index].from=values.from
                plannedDowntimes[machine?.machineName||'Default'][index].to=values.to
                plannedDowntimes[machine?.machineName||'Default'][index].reason=values.reason
            }
            else{
                plannedDowntimes[machine?.machineName||'Default'][index].maxMinutes=values.maxMinutes
                plannedDowntimes[machine?.machineName||'Default'][index].reason=values.reason
            }
            //console.log(plannedDowntimes);
            updatedLog ={plannedDowntimes}
            //await editAlert(dispatch, { values, lineOps, rec: switches?.prevRec }, current)
        }
        if (doWhat !== 'edit'){
            let pdId = uuidv4();
            if(Array.isArray(plannedDowntimes[machine?.machineName||'Default'])){
                plannedDowntimes[machine?.machineName||'Default'].push({...values,'plantId':plant._id,'lineId':line._id,'machine':machine?.machineName || null,pdId});
              }else{
                plannedDowntimes[machine?.machineName||'Default']=[]
                plannedDowntimes[machine?.machineName||'Default'].push({...values,'plantId':plant._id,'lineId':line._id,'machine':machine?.machineName || null,pdId})
              }
            //plannedDowntimes[machine?.machineName||'Default'].push({...values,'plantId':plant._id,'lineId':line._id,'machine':machine?.machineName || null,pdId})//{...plannedDowntimes,values}
            //console.log(plannedDowntimes);
            updatedLog ={plannedDowntimes};
            let plannedDowntimeObject = {...values,'plantId':plant._id,'lineId':line._id,'machine':machine?.machineName || null,pdId}
            
            createPlannedDowntime(plannedDowntimeObject)
        }
        let body = {
            plantId:plant?._id,
            updatedAt: `${moment(Date.now()).format(`${"YYYY-MM-DDThh:mm:ss.ms"}`)}Z`,
            _id: line?._id,
            ...updatedLog
          }
            //await createAlert(dispatch, { ...values, lineOps }, current)
        onDowntimeValuesSubmit(dispatch, body)
    
        setDoWhat('create')
        setStoppageModal(false)
        setDowntimeModal(false)
    };

    const onFinishFailed = (errorInfo) => {
        console.log("Failed:", errorInfo);
    };

    const handleEdit = (record) => {
        console.log({ record, lines: record?.lines?.map((line) => ({ label: line.lineName, value: line?.id })) })
        setDoWhat('edit')
        setCurrent(record);
        form.setFieldsValue({
            from:record?.from,
            reason:record?.reason,
            to:record?.to,
            maxMinutes:record?.maxMinutes,
            pdId:record?.pdId,
        })
        if(record.maxMinutes)
            setStoppageModal(true)
        else    
            setDowntimeModal(true)
    }

    const handleDelete = async (record) => {
        let plannedDowntimes = []
        let updatedLog = null;
        let { plant = null, line = null, machine = null } = JSON.parse(localStorage.getItem('current'))
        plannedDowntimes = line.plannedDowntimes;
        plannedDowntimes[machine?.machineName||'Default'] = plannedDowntimes[machine?.machineName||'Default'].filter(pd => pd.pdId != record.pdId);
        updatedLog = {plannedDowntimes}
        
        let body = {
            plantId:plant?._id,
            updatedAt: `${moment(Date.now()).format(`${"YYYY-MM-DDThh:mm:ss.ms"}`)}Z`,
            _id: line?._id,
            ...updatedLog
          }
            //await createAlert(dispatch, { ...values, lineOps }, current)
        onDowntimeValuesSubmit(dispatch, body)
    
        //console.log(record)
        //await deleteAlert(dispatch, { lineOps, rec: record }, current)
    }
    const sync = async() => {
        // if((admin('shift-access')))
        // {
        //   notification.error({
        //     message: 'Not have access to sync. ',
        //   });
        //   //this.handleCancel();
        //   return;
        // }
        //   try {
        //     await syncMachineShifts({plantId: current?.plant?._id, lineId: current?.line?.id, machines: selectedMachines, productionLine:{
        //       shifts:current?.shift?.name, 
        //       machines:current?.machine?.machines
        //     },machine})
        //     notification.success({
        //       message: 'Sync Successful',
        //     });
    
        //   }
        // catch(err) {
        //   console.log(err)
        //   notification.error({
        //     message: 'Sync Failed',
        //   });
        // }
    }
    const DowntimeModal = () => {

        return (
            <Modal
                title={<h2>{add_downtime}</h2>}
                centered
                open={downtimeModal}
                maskClosable={false}
                onCancel={() => setDowntimeModal(false)}
                footer={null}
                className="downtimeModal"
            >
                <Spin indicator={antIcon} spinning={componentLoaders?.downtimeModal || false} >
                <div>
                <Form
                        form={form}
                        name="downtimeForm"
                        className="downtimeForm"
                        labelCol={{
                            span: 8,
                        }}
                        wrapperCol={{
                            span: 24,
                        }}
                        initialValues={{
                            remember: false,
                        }}
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        autoComplete="off"
                    >
                        <Row gutter={6}>
                            <Col span={12}>
                                <h4>{downtime}</h4>
                                <Form.Item
                                    name="from"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please select time!",
                                        },
                                    ]}
                                >
                                    <Input className="boxBorderRad width100P" placeholder={"From"} />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                            <h4> </h4>
                                <Form.Item
                                    name="to"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please select time!",
                                        },
                                    ]}
                                >
                                    <Input className="boxBorderRad width100P" placeholder={"To"} />
                                </Form.Item>
                            </Col>
                        </Row>
                        <h4>{reason}</h4>
                        <Form.Item
                            name="reason"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Enter Reason",
                                },
                            ]}
                        >
                          <Input className="boxBorderRad width100P" placeholder="Enter Reason"></Input>
                        </Form.Item>
                        <Row className="dflex alignCenter justifyCenter gap10" >
                    <Form.Item>
                        <ButtonComp
                            style={{ width: "180px" }}
                            theme={"blue"}
                            htmlType="submit"
                            text={"Apply"}
                            icon={<CheckCircleFilled />}
                        />
                    </Form.Item>
                    <Form.Item>
                        <ButtonComp
                            style={{ width: "180px" }}
                            theme={"red"}
                            text={"Cancel"}
                            icon={<CloseCircleFilled />}
                            // onClick={handleCancel}
                        />
                    </Form.Item>
                </Row>
                    </Form>
        </div>
                </Spin>
            </Modal >
        );
    };

    const StoppageModal = () => {

        return (
            <Modal
                title={<h2>{add_stoppage}</h2>}
                centered
                open={stoppageModal}
                onCancel={() => setStoppageModal(false)}
                maskClosable={false}
                footer={null}
                className="stoppageModal"
            >
                <Spin indicator={antIcon} spinning={componentLoaders?.stoppageModal || false} >
                <div>
                <Form
                        form={form}
                        name="stoppageForm"
                        className="stoppageForm"
                        labelCol={{
                            span: 8,
                        }}
                        wrapperCol={{
                            span: 24,
                        }}
                        initialValues={{
                            remember: false,
                        }}
                        onFinish={onFinish}
                        onFinishFailed={onFinishFailed}
                        autoComplete="off"
                    >
                        <h4>{reason}</h4>
                        <Form.Item
                            name="reason"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Enter Reason!",
                                },
                            ]}
                        >
                           <Input className="boxBorderRad width100P" placeholder={"Enter Reason"} />
                        </Form.Item>
                        <h4>{stoppage_time}</h4>
                        <Form.Item
                            name="maxMinutes"
                            rules={[
                                {
                                    required: true,
                                    message: "Please Enter Stoppage Time",
                                },
                            ]}
                        >
                          <InputNumber className="boxBorderRad width100P" placeholder={"Enter Reason"} type="number" />
                        </Form.Item>
                        <Row className="dflex alignCenter justifyCenter gap10" >
                    <Form.Item>
                        <ButtonComp
                            style={{ width: "180px" }}
                            theme={"blue"}
                            htmlType="submit"
                            text={"Apply"}
                            icon={<CheckCircleFilled />}
                        />
                    </Form.Item>
                    <Form.Item>
                        <ButtonComp
                            style={{ width: "180px" }}
                            theme={"red"}
                            text={"Cancel"}
                            icon={<CloseCircleFilled />}
                            // onClick={handleCancel}
                        />
                    </Form.Item>
                </Row>
                    </Form>
        </div>
                </Spin>
            </Modal >
        );
    };

    const PlannedDowntimeTableColumns = [
        {
            title: "From",
            dataIndex: "from",
            render: (text, record) =>  (
                <>
                {<div>{record?.from}</div>
                }
            </>
            )
        },
        {
            title: 'To',
            dataIndex: 'to',
            render: (text, record) =>  (
                <>
                {<div>{record?.to}</div>
                }
            </>
            )
        },
        {
            title: 'Reason',
            dataIndex: 'reason',
            render: (text, record) =>  (
                <>
                {<div>{record?.reason}</div>
                }
            </>
            )
        },
    ]
    // if (canPerformAction(current, access_capabilities.canEditLineSettings)) {
        PlannedDowntimeTableColumns.push({
            title: 'Actions',
            dataIndex: 'actions',
            render: (key, rec) => (<div className='dflex alignCenter justifyCenter gap10'>
            <img onClick={() => handleEdit(rec)} src={edit} className="cursorPointer" /> 
            <Popconfirm placement="topRight" okText="Delete" cancelText="Cancel" okButtonProps={{className: "popRed"}} cancelButtonProps={{className: "popBlue"}} title="Confirm delete ?" onConfirm={() => { handleDelete(rec) }}>
            <img src={trash} className="cursorPointer" />
            </Popconfirm>
            </div>
            ),
            align: "center"
         });
    // }
    const PlannedStoppageTableColumns = [
        {
            title: "Stoppage Time",
            dataIndex: "maxMinutes",
            render: (text, record) =>  (
                <>
                {<div>{record?.maxMinutes}</div>
                }
            </>
            )
        },
        {
            title: 'Reason',
            dataIndex: 'reason',
            render: (text, record) =>  (
                <>
                {<div>{record?.reason}</div>
                }
            </>
            )
        },
    ]
    // if (canPerformAction(current, access_capabilities.canEditLineSettings)) {
        PlannedStoppageTableColumns.push({
            title: 'Actions',
            dataIndex: 'actions',
            render: (key, rec) => (<div className='dflex alignCenter justifyCenter gap10'><img onClick={() => handleEdit(rec)} src={edit} className="cursorPointer" />
            <Popconfirm placement="topRight" okText="Delete" cancelText="Cancel" okButtonProps={{className: "popRed"}} cancelButtonProps={{className: "popBlue"}} title="Confirm delete ?" onConfirm={() => { handleDelete(rec) }}>
            <img src={trash} className="cursorPointer" />
            </Popconfirm>
            </div>
            ),
            align: "center"
         });
    // }
    return (
        <>
        <Row className="pt1">
            <Row className="width100P">
                <Col span={12}>
                    <h1 className="pageHead">{heading1}</h1>
                </Col>
                {/* {canPerformAction(current, access_capabilities.canEditLineSettings) && ( */}
                <Col span={12} className="dflex justifyFE">
                    <ButtonComp
                        onClick={() => { form.resetFields(); setDowntimeModal(true); }}
                        theme="blue"
                        text="Add Planned Downtime"
                        img={"notification-bing"}
                    />{" "}
                    <DowntimeModal />
                </Col>
                {/* )} */}
            </Row>
            <Row className="width100P pt10 ">
                <Col span={24}>
                    <CustomTable
                        columns={PlannedDowntimeTableColumns}
                        dataSource={downtimeSettings}
                    />
                </Col>
            </Row>
            </Row>
            <Row className="pt1">
            <Row className="width100P">
                <Col span={12}>
                    <h1 className="pageHead">{heading2}</h1>
                </Col>
                {/* {canPerformAction(current, access_capabilities.canEditLineSettings) && ( */}
                <Col span={12} className="dflex justifyFE">
                    <ButtonComp
                        onClick={() => { form.resetFields(); setStoppageModal(true); }}
                        theme="blue"
                        text="Add Planned Stoppage"
                        img={"notification-bing"}
                    />{" "}
                    <StoppageModal />
                </Col>
                {/* )} */}
            </Row>
            <Row className="width100P pt10 ">
                <Col span={24}>
                    <CustomTable
                        columns={PlannedStoppageTableColumns}
                        dataSource={stoppageSettings}
                    />
                </Col>
            </Row>
            </Row>
            <Form>
            <SyncMachine
             machine={machine}
            //  canSync={(x) => canSync(x)}
             selectedMachines={selectedMachines}
             sync={sync}
             productionLine={current?.line?.productionLine}
             changeMachines = {(machines) => {setState(machines)}} />
        </Form>
    </>
    );
};

export default PlannedDowntime;
